export const GRAPH_CONFIG = {
  apiBase: process.env.REACT_APP_BOOKINGS_API_BASE_URL ?? '/api/bookings',
  bookingsTimeZone: process.env.REACT_APP_BOOKINGS_TIMEZONE ?? 'India Standard Time',
}
